import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { Head } from '@cinch-nx/landing-ui-shared'
import {
  ComponentLayouts,
  StoryblokRendererV2 as StoryblokRenderer,
} from '@cinch-nx/storyblok-utils'
import { ReturnsProps } from './get-static-props'
import { storyblokComponentsReturns } from './storyblok/data/storyblok-renderer-map'
import { ReturnsStory } from './storyblok/storyblok'

export const Returns = ({ story, preview }: ReturnsProps) => {
  const { content } = useStoryblokState<ReturnsStory>({
    story,
    enableBridge: preview,
  })

  const SEO = content.SEO?.[0] ?? {}

  const componentLayouts: ComponentLayouts = {
    slimWrapper: storyblokComponentsReturns,
  }

  return (
    <>
      <Head
        {...SEO}
        fallbackTitle="Returns: Money-back guarantee | cinch.co.uk - cinch"
        fallbackDescription="Finding. Buying. Selling. It's a cinch. Buy at a price that's right for you. Monthly Instalments. Car Value Calculator. Compare Offers. Types: Make & Model, Mileage, Age, Engine Size, Fuel Type, Doors, Colour, Body Style, Gearbox."
      />
      <article>
        <StoryblokRenderer block={content.body} components={componentLayouts} />
      </article>
    </>
  )
}
